var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24992 20.1668H13.7499C18.3333 20.1668 20.1666 18.3335 20.1666 13.7502V8.25016C20.1666 3.66683 18.3333 1.8335 13.7499 1.8335H8.24992C3.66659 1.8335 1.83325 3.66683 1.83325 8.25016V13.7502C1.83325 18.3335 3.66659 20.1668 8.24992 20.1668Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71924 13.2823L8.9009 10.4498C9.21257 10.0465 9.79007 9.97312 10.1934 10.2848L11.8709 11.6048C12.2742 11.9165 12.8517 11.8431 13.1634 11.449L15.2809 8.71729",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.6d0c9f5f9cbaa7cd0dba07d6559f8ba2.svg";
export { ForwardRef as ReactComponent };